import { Component, OnInit, Input } from '@angular/core';
import { PreviewFrameService } from '@scaffold/tools/preview-frame/preview-frame.service';
import { CourseService } from '@scaffold/services/course.service';
import { UserService } from '@app/services/user.service';

@Component({
  selector: 'scaffold-file-view',
  templateUrl: './scaffold-file-view.component.html',
  styleUrls: ['./scaffold-file-view.component.scss']
})
export class ScaffoldFileViewComponent implements OnInit {
  @Input() item
  constructor(private courseService: CourseService, private previewFrameService: PreviewFrameService, private userService: UserService) { }
  download_url;
  ngOnInit() {
    // console.log(this.item)
  }

  openFile(e: Event, file, title) {
    e.preventDefault();
    // this.download_url = "/files/" + file;
    this.userService.isLoggedIn().subscribe(
      (loggedIn) => {
        if (loggedIn) {
          this.previewFrameService.openPreview(file,this.item, '',title);
        }
      })
    //var win = window.open(url, '_blank');
    /*setTimeout(i => {
      this.download_url = undefined;
    },2000)*/

  }
}
